import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';


function WebHSC() {

  const params = useParams();
  const udiseNumber = params.udiseNumber;
  const srNo = params.srNo;
  const academicYear = params.academicYear;
  const classValue = params.classValue;
  const selectedExamName = params.selectedExamName;
  const division = params.division; 
  const [studentData, setStudentData] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [marksData, setMarksData] = useState({});
  const [selectedStudentResults, setSelectedStudentResults] = useState(null);
  const [showModal, setShowModal] = useState(true);
  const [schoolName, setSchoolName] = useState('');
  const [schoolLogo, setSchoolLogo] = useState('');
  const [divisions, setDivisions] = useState([]);
  const [divisionSubjects, setDivisionSubjects] = useState({}); // Store subjects by class and division


  const [examNames, setExamNames] = useState ([
    "Unit Test I",
    "Unit Test II",
    "Semester First ",
    "Semester Second ",
    "All Exams",
  ]);

  const examNameTranslations = {
    "Unit Test I": "घटक चाचणी-1",
    "Unit Test II": "घटक चाचणी-2",
    "Semester First ": "प्रथम सत्र",

    "Semester Second ": "द्वितीय सत्र",
    "Second": "द्वितीय",


  };

  // Reset divisions when class changes
  useEffect(() => {
    if (classValue && studentData && Array.isArray(studentData)) {
      const divisionsForClass = studentData
        .filter(student => student.currentClass === classValue)
        .map(student => student.division)
        .filter((value, index, self) => value && self.indexOf(value) === index);
      setDivisions(divisionsForClass);
    } else {
      setDivisions([]);
    }
  }, [classValue, studentData]);

  useEffect(() => {
    const fetchDefaultSettings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/defaultSettings.json`);
        if (response.ok) {
          const data = await response.json();

         
        } else {
          console.error("Failed to fetch default settings.");
        }
      } catch (error) {
        console.error("Error fetching default settings:", error);
      }
    };

    fetchDefaultSettings();
  }, [udiseNumber]);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');




  const [subjectSequence, setSubjectSequence] = useState([]); // New state for subject sequence
  useEffect(() => {
    console.log('ac', academicYear);
    console.log('c', classValue);
    console.log('a', division);

    if (academicYear && classValue && division) {
      fetchSubjectSequence();
    }
  }, [academicYear, classValue, division]);



  const fetchSubjectSequence = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/hsc/${academicYear}/${classValue}/${division}.json`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch subject sequence');
      }
      const data = await response.json();
      if (data) {
        const orderedSubjects = Object.keys(data)
          .map(key => data[key]); // Map keys to subject names
        setSubjectSequence(orderedSubjects);
      } else {
        setSubjectSequence([]);
      }
    } catch (error) {
      console.error('Error fetching subject sequence:', error);
    }
  };

  useEffect(() => {
    if (academicYear && classValue && division) {
      fetchSubjectSequence();
    }
  }, [academicYear, classValue, division]);

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);


  const fetchSchoolName = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch school name');
      }
      const data = await response.json();
      setSchoolName(data.schoolName || '-');
      setSchoolLogo(data.schoolLogo || ''); // Add this line
    } catch (error) {
      console.error('Error fetching school name:', error);
    }
  };
  useEffect(() => {
    fetchSchoolName();
    fetchStudentData();
  }, []);

  useEffect(() => {
    if (selectedExamName && classValue && academicYear && division) {
      fetchMarksForSelectedSubject();
    }
  }, [selectedExamName, classValue, academicYear, division]);

  const filteredExamNames = examNames.filter((examName) => examName === "Semester Second ");

  // Modify the existing fetchStudentData function
  const fetchStudentData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}.json`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch student data');
      }
      const data = await response.json();
      const processedData = processStudentData(data);
      setStudentData(processedData || []);
    } catch (error) {
      console.error('Error fetching student data:', error);
    }
  };

  const processStudentData = (data) => {
    const processedData = {};
    if (data) {
      for (const subject in data) {
        if (subject !== 'nondi') {
          const akarikTotal = data[subject]?.Akarik?.Total || 0;
          const sanklikTotal = data[subject]?.Sanklik?.Total || 0;
          processedData[subject] = {
            ...data[subject],
            total: akarikTotal + sanklikTotal
          };
        }
      }
    }
    return processedData;
  };

  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        // Fetch basic student info
        const response = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}.json`
        );
        if (!response.ok) {
          throw new Error('Failed to fetch student info');
        }
        const studentInfo = await response.json();

        let fetchedExamData = {};

        if (selectedExamName === "All Exams") {
          // Fetch data for all exams
          const examNames = ["Semester First ", "Semester Second ", "Unit Test I", "Unit Test II", "Unit Test III", "Unit Test IV"];
          for (const examName of examNames) {
            const examResponse = await fetch(
              `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/${examName}.json`
            );
            if (!examResponse.ok) {
              console.warn(`Failed to fetch ${examName} data, using empty object`);
              fetchedExamData[examName] = {};
            } else {
              fetchedExamData[examName] = await examResponse.json();
            }
          }
        } else {
          // Fetch data for a specific exam
          const examResponse = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/${selectedExamName}.json`
          );
          if (!examResponse.ok) {
            console.warn(`Failed to fetch ${selectedExamName} data, using empty object`);
            fetchedExamData[selectedExamName] = {};
          } else {
            fetchedExamData[selectedExamName] = await examResponse.json();
          }
        }

        // Process fetched data
        const processedResults = {};
        let allSubjects = new Set();

        if (selectedExamName === "All Exams") {
          // Collect subjects from all exams
          for (const examName in fetchedExamData) {
            allSubjects = new Set([...allSubjects, ...Object.keys(fetchedExamData[examName] || {})]);
          }

          allSubjects.forEach((subject) => {
            processedResults[subject] = {};
            for (const examName in fetchedExamData) {
              const examData = fetchedExamData[examName];
              if (examData && examData[subject]) {
                processedResults[subject][examName] = { ...examData[subject] };
                if (examData[subject].subtype === "Mark") {
                  processedResults[subject][examName].totalObtained =
                    (examData[subject].obtainMarks || 0) + (examData[subject].graceMarks || 0);
                }
              }
            }
          });
        } else {
          // Collect subjects from specific exam
          allSubjects = new Set(Object.keys(fetchedExamData[selectedExamName] || {}));
          allSubjects.forEach((subject) => {
            processedResults[subject] = {};
            if (fetchedExamData[selectedExamName] && fetchedExamData[selectedExamName][subject]) {
              processedResults[subject] = { ...fetchedExamData[selectedExamName][subject] };
              if (fetchedExamData[selectedExamName][subject].subtype === "Mark") {
                processedResults[subject].totalObtained =
                  (fetchedExamData[selectedExamName][subject].obtainMarks || 0) +
                  (fetchedExamData[selectedExamName][subject].graceMarks || 0);
              }
            }
          });
        }

        console.log("Processed Results:", processedResults);

        // Update the state with all the necessary data
        setSelectedStudentResults({
          studentName: studentInfo.stdName,
          stdMother: studentInfo.stdMother,
          stdFather: studentInfo.stdFather,
          stdSurname: studentInfo.stdSurname,
          dob: studentInfo.dob,
          division: studentInfo.division,
          motherTounge: studentInfo.motherTounge,
          studentId: studentInfo.studentId,
          gender: studentInfo.gender,
          rollNo: studentInfo.rollNo,
          results: processedResults,
          stdPhoto: studentInfo.stdPhoto,
        });
        setShowModal(true);
      } catch (error) {
        console.error("Error fetching student data:", error);
      }
    };

    if (academicYear && classValue && selectedExamName && srNo && division) {
      fetchStudentData();
    }
  }, [academicYear, classValue, selectedExamName, srNo, division]);

  useEffect(() => {
    fetchSchoolName();
    if (academicYear && classValue && selectedExamName && srNo && division) {
      fetchStudentData();
    }
  }, [academicYear, classValue, selectedExamName, srNo, division]);

  useEffect(() => {
    if (academicYear && classValue && selectedExamName && srNo && division) {
      fetchStudentData();
    }
  }, [academicYear, classValue, selectedExamName, srNo, division]);

  const fetchSubjectsForClassAndDivision = async (classValue, division) => {
    try {
      if (!classValue || !division || !academicYear) {
        console.error("Class, division, or academic year not set");
        return;
      }

      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/subjectSequence/${academicYear}/${classValue}/${division}.json`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch subjects for class ${classValue} and division ${division}`);
      }
      const subjectsData = await response.json();
      if (subjectsData) {
        const validSubjects = Object.entries(subjectsData)
          .filter(([_, value]) => value !== null && value !== undefined)
          .map(([_, subject]) => subject);

        setDivisionSubjects(prev => ({
          ...prev,
          [classValue]: {
            ...prev[classValue],
            [division]: validSubjects,
          },
        }));
      } else {
        setDivisionSubjects(prev => ({
          ...prev,
          [classValue]: {
            ...prev[classValue],
            [division]: [],
          },
        }));
      }
    } catch (error) {
      console.error(`Error fetching subjects: ${error}`);
    }
  };

  // Fetch subjects when class or division changes
  useEffect(() => {
    if (classValue && division) {
      fetchSubjectsForClassAndDivision(classValue, division);
    }
  }, [classValue, division, academicYear]);
  const fetchMarksForSelectedSubject = async () => {
    try {
      const selectedStudents = studentData.filter(
        (student) => student.currentClass === classValue && student.division === division
      );
      setSelectedStudents(selectedStudents);
      const marksDataPromises = selectedStudents.map(async (student) => {
        const studentMarks = await fetchMarksData(
          student.srNo,
          academicYear,
          selectedExamName
        );
        return { srNo: student.srNo, marks: studentMarks };
      });
      const marksDataArray = await Promise.all(marksDataPromises);
      const marksData = marksDataArray.reduce((acc, { srNo, marks }) => {
        acc[srNo] = marks;
        return acc;
      }, {});
      setMarksData(marksData);
    } catch (error) {
      console.error('Error fetching marks data:', error);
    }
  };

  const fetchMarksData = async (srNo, academicYear, examName) => {
    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/${examName}.json`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Error fetching data: ${response.statusText}`);
      }
      const data = await response.json();
      console.log(`Marks for ${srNo} in ${examName}:`, data); // Updated log to include exam name
      return data || {};
    } catch (error) {
      console.error('Error fetching marks data:', error);
      return {};
    }
  };


  const [selectedStudentForSr, setSelectedStudentForSr] = useState('')

  const viewResult = async (srNo) => {
    try {
      const student = selectedStudents.find((student) => student.srNo === srNo);
      setSelectedStudentForSr(student);
      if (!student) {
        throw new Error("Student not found");
      }
      let results = {};
      if (selectedExamName === "All Exams") {
        // Fetch data for all exams
        const exams = ["Unit Test I", "Unit Test II", "Semester First ", "Semester Second "];
        const promises = exams.map((exam) => {
          return fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/${exam}.json`
          )
            .then((response) => response.json())
            .then((data) => ({ exam, data }));
        });
        const examResults = await Promise.all(promises);
        results = examResults.reduce((acc, { exam, data }) => {
          acc[exam] = data;
          return acc;
        }, {});
        // Combine the data into a single object
        const combinedResults = {};
        Object.keys(results).forEach((exam) => {
          Object.keys(results[exam]).forEach((subject) => {
            if (!combinedResults[subject]) {
              combinedResults[subject] = {};
            }
            combinedResults[subject][exam] = results[exam][subject];
          });
        });
        results = combinedResults;
      } else {
        const response = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}/${selectedExamName}.json`
        );
        if (!response.ok) {
          throw new Error('Failed to fetch student data');
        }
        const data = await response.json();
        results = processStudentData(data);
      }

      console.log('Results before setting state:', results);

      setSelectedStudentResults({
        studentName: student.stdName,
        results: results,
        stdMother: student.stdMother,
        stdFather: student.stdFather,
        stdSurname: student.stdSurname,
        dob: student.dob,
        division: student.division,
        motherTounge: student.motherTounge,
        studentId: student.studentId,
        gender: student.gender,
        registerNo: student.registerNo,
        rollNo: student.rollNo,
        stdPhoto: student.stdPhoto,
      });
      // Show the results modal
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching student results:", error);
    }
  };


  useEffect(() => {
    console.log('Student Data:', studentData);
    console.log('Selected Student Results:', selectedStudentResults);
  }, [studentData, selectedStudentResults]);

  const calculateGradeEnglish = (total) => {
    if (total >= 90) return 'A+';
    if (total >= 80) return 'A';
    if (total >= 70) return 'B+';
    if (total >= 60) return 'B';
    if (total >= 50) return 'C+';
    if (total >= 40) return 'C';
    if (total >= 30) return 'D+';
    if (total >= 20) return 'D';
    return 'Fail';
  };

  const calculateGradeMarathi = (total) => {
    if (total >= 90) return 'अ-1';
    if (total >= 80) return 'अ-2';
    if (total >= 70) return 'ब-1';
    if (total >= 60) return 'ब-2';
    if (total >= 50) return 'क-1';
    if (total >= 40) return 'क-2';
    if (total >= 30) return 'ड-1';
    if (total >= 20) return 'ड-2';
    return 'नापास';
  };
  // Function to calculate grade based on the current language
  const calculateGrade = (total) => {
    return language === 'English' ? calculateGradeEnglish(total) : calculateGradeMarathi(total);
  };
  const handleCloseModal = () => setShowModal(false);
  //  setting marks to pass 
  const getPassingMarks = (currentClass) => {
    if (selectedStudentForSr.currentClass === "Class V" || selectedStudentForSr.currentClass === "इयत्ता पाचवी") {
      return 18;
    } else if (selectedStudentForSr.currentClass === "Class VIII" || selectedStudentForSr.currentClass === "इयत्ता आठवी") {
      return 21;
    }
    // Default passing marks if none of the specified classes are selected
    return 18;
  };


  const calculateTotalMarks = (data) => {
    if (!data) {
      return []; // Return an empty array if data is null or undefined
    }
    const subjects = Object.keys(data).filter(subject => subject !== 'nondi');
    const totals = subjects.map(subject => {
      const akarikTotal = data[subject]?.Akarik?.Total || 0;
      const sanklikTotal = data[subject]?.Sanklik?.Total || 0;
      return {
        subject,
        total: akarikTotal + sanklikTotal
      };
    });
    return totals;
  };

  useEffect(() => {
    const fetchAndCalculateMarks = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData/${srNo}/result/${academicYear}.json`
        );
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        const firstSemesterData = data['First Semester '];
        const secondSemesterData = data['Second Semester '];

        const firstSemesterTotals = calculateTotalMarks(firstSemesterData);
        const secondSemesterTotals = calculateTotalMarks(secondSemesterData);

        console.log('First Semester Totals:', firstSemesterTotals);
        console.log('Second Semester Totals:', secondSemesterTotals);
      } catch (error) {
        console.error('Error fetching or calculating marks:', error);
      }
    };

    fetchAndCalculateMarks();
  }, []);

  return (
    <div>
      {/* <AlertMessage message={alertMessage} show={showAlert} /> */}


      <div className=' main-content-of-page'>
      
        {selectedStudents.length > 0 && (
          <div className="mt-4">
            <table className="table table-striped table-bordered custom-table">
              <thead>
                <tr>
                  <th className="custom-width">{language === "English" ? "Roll No " : "हजेरी क्र"}</th>
                  <th>{language === "English" ? "Student Name " : "विद्यार्थ्याचे नाव"}</th>
                  <th>{language === "English" ? "result " : "प्रगतीपत्रक"}</th>
                </tr>
              </thead>
              <tbody>
                {selectedStudents.filter((student) => student.division === division).sort((a, b) => a.rollNo - b.rollNo).map((student) => (
                  <tr key={student.srNo}>
                    <td>{student.rollNo}</td>
                    <td>{student.stdName} {student.stdSurname}</td>
                    <td>
                      <button className="btn btn-primary" onClick={() => viewResult(student.srNo)}>
                        {language === "English" ? "View result" : "प्रगति पत्रक"}
                      </button>

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}


        <Modal show={showModal} onHide={handleCloseModal} dialogClassName='modal-80w'>
        
          <Modal.Body>
            {selectedExamName === 'All Exams' && selectedStudentResults ? (


              
              <div>
                {/* Semester Second  modal content */}
                <div className="r mt-1" style={{}}>
                  <div className="left" style={{
                    width: '615px',
                    height: '900px',
                    margin: '0 auto', // Center the div horizontally
                    padding: '20px', // Add some padding
                    border: '2px solid #000', // Optional: Add a border for visibility
                    boxSizing: 'border-box', // Include padding and border in the element's total width and height
                    overflow: 'hidden' // Prevent overflow if content is too large
                  }}>
                    <div className="school-info" >
                      {schoolLogo && (
                        <div>
                          <img
                            src={schoolLogo}
                            alt="Logo"
                            style={{ width: '80px', height: 'auto', objectFit: 'contain' }}
                          />
                        </div>
                      )}
                      <h2>{schoolName}</h2>
                    </div>
                    <div>
                      <hr style={{
                        width: 'calc(100% + 40px)', // Adjust width to account for padding
                        height: '2px',
                        backgroundColor: 'black',
                        border: 'none',
                        marginLeft: '-20px', // Negative margin to pull it to the left
                        marginRight: '-20px', // Negative margin to pull it to the right
                        marginBottom: '6px', // Adjust this value to reduce the gap below the hr
                      }} />
                      <b>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? "PROGRESS REPORT" : "विद्यार्थी प्रगती अहवाल"}
                        </h6>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? `SECOND SEMESTER EXAMINATION- ${academicYear}` : `प्रथम सत्र परीक्षा-  ${academicYear}`}
                        </h6>
                      </b>
                      <hr style={{
                        width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '6px', marginBottom: '6px',
                      }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
                      <div style={{ flex: '1', textAlign: 'left' }}>
                        <label htmlFor="roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Roll No : " : "हजेरी क्रमांक : "}</label>
                        <span>{selectedStudentResults?.rollNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'center' }}>
                        <label htmlFor="Register No" style={{ fontSize: '14px' }}>{language === "English" ? "Register No : " : "रजिस्टर क्रमांक : "}</label>
                        <span>{selectedStudentResults?.registerNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'right', }}>
                        <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Class : " : "वर्ग : "}</label>
                        <span>{classValue || '-'} {division || '-'}</span>
                      </div>
                    </div>
                    <hr style={{
                      width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '1px'
                    }} />
                    <div style={{ fontSize: '14px', marginLeft: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ width: '70%' }}>
                        <div>
                          <label htmlFor="student-name" style={{ fontSize: '14px' }}>{language === "English" ? "Student Name : " : "विद्यार्थ्याचे नाव : "}</label>
                          <span>{selectedStudentResults?.studentName || '-'} {selectedStudentResults?.stdFather || '-'} {selectedStudentResults?.stdSurname || '-'}</span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Mother Name : " : "आईचे वर्ग : "}</label>
                          <span>{selectedStudentResults?.stdMother || '-'} </span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Date Of Birth : " : "जन्मतारीख : "}</label>
                          <span>{selectedStudentResults?.dob ? selectedStudentResults.dob.split('-').reverse().join('-') : '-'} </span>
                        </div>
                        <div>
                          <label htmlFor="exam-roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Exam : " : "परीक्षा सत्र : "}</label>
                          <span>{selectedExamName || '-'}</span>
                        </div>
                      </div>
                      <div style={{ width: '30%' }}>
                        {selectedStudentResults?.stdPhoto && (
                          <img src={selectedStudentResults?.stdPhoto} style={{ width: '80px', height: '80px' }} />
                        )}
                      </div>
                    </div>






                    {selectedStudentResults?.results ? (
                      <table className="table table-striped table-bordered" style={{ fontSize: '12px', padding: '5px' }}>
                        <thead>
                          <tr>
                            <th rowSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Subject" : "विषय"}</th>
                            {selectedExamName === "All Exams" ? (
                              <>
                                <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test I" : "पहिली चाचणी"}</th>
                                <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Unit Test II" : "दुसरी चाचणी"}</th>
                                <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Semester I " : "प्रथम सत्र"}</th>
                                <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{language === "English" ? "Semester II " : "द्वितीय सत्र"}</th>
                              </>
                            ) : (
                              <th colSpan="2" style={{ padding: '3px', color: 'black' }}>{selectedExamName}</th>
                            )}
                          </tr>
                          <tr>
                            {selectedExamName === "All Exams" ? (
                              <>
                                <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                                <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                                <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                                <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                                <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                                <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                                <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                                <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                              </>
                            ) : (
                              <>
                                <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "M.M" : "पैकी"}</th>
                                <th style={{ padding: '4px', color: 'black', fontWeight: 'normal' }}>{language === "English" ? "Obt.M" : "गुण"}</th>
                              </>
                            )}
                          </tr>
                        </thead>

                        <tbody>
                          {selectedStudentResults && selectedStudentResults.results ? (
                            subjectSequence
                              .filter((subject) => {
                                const grades = selectedStudentResults.results[subject];
                                return (
                                  grades &&
                                  (grades["Unit Test I"]?.obtainMarks ||
                                    grades["Unit Test II"]?.obtainMarks ||
                                    grades["Semester First "]?.obtainMarks ||
                                    grades["Semester Second "]?.obtainMarks ||
                                    grades.grade)
                                );
                              })
                              .map((subject) => {
                                const grades = selectedStudentResults?.results?.[subject]; // Added null check here
                                return (
                                  <tr key={subject} style={{ padding: "2px" }}>
                                    <td style={{ padding: "2px", color: 'black' }}>
                                      {subject}
                                    </td>
                                    {selectedExamName === "All Exams" ? (
                                      <>
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Unit Test I"]?.subtype === "Grade"
                                            ? "-"
                                            : (grades?.["Unit Test I"]?.outOf || "-")}
                                        </td>
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Unit Test I"]?.subtype === "Grade"
                                            ? grades?.["Unit Test I"]?.grade
                                            : (grades?.["Unit Test I"]?.obtainMarks || "-")}
                                        </td>
                                        {/* Add Written Marks */}
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Unit Test I"]?.writtenMarks || "-"}
                                        </td>
                                        {/* Add Oral Marks */}
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Unit Test I"]?.oralMarks || "-"}
                                        </td>
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Unit Test II"]?.subtype === "Grade"
                                            ? "-"
                                            : (grades?.["Unit Test II"]?.outOf || "-")}
                                        </td>
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Unit Test II"]?.subtype === "Grade"
                                            ? grades?.["Unit Test II"]?.grade
                                            : (grades?.["Unit Test II"]?.obtainMarks || "-")}
                                        </td>
                                        {/* Add Written Marks */}
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Unit Test II"]?.writtenMarks || "-"}
                                        </td>
                                        {/* Add Oral Marks */}
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Unit Test II"]?.oralMarks || "-"}
                                        </td>
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Semester First "]?.subtype === "Grade"
                                            ? "-"
                                            : (grades?.["Semester First "]?.outOf || "-")}
                                        </td>
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Semester First "]?.subtype === "Grade"
                                            ? grades?.["Semester First "]?.grade
                                            : (grades?.["Semester First "]?.obtainMarks || "-")}
                                        </td>
                                        {/* Add Written Marks */}
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Semester First "]?.writtenMarks || "-"}
                                        </td>
                                        {/* Add Oral Marks */}
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Semester First "]?.oralMarks || "-"}
                                        </td>
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Semester Second "]?.subtype === "Grade"
                                            ? "-"
                                            : (grades?.["Semester Second "]?.outOf || "-")}
                                        </td>
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Semester Second "]?.subtype === "Grade"
                                            ? grades?.["Semester Second "]?.grade
                                            : (grades?.["Semester Second "]?.obtainMarks || "-")}
                                        </td>
                                        {/* Add Written Marks */}
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Semester Second "]?.writtenMarks || "-"}
                                        </td>
                                        {/* Add Oral Marks */}
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.["Semester Second "]?.oralMarks || "-"}
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.subtype === "Grade" ? "-" : (grades?.outOf || "-")}
                                        </td>
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.subtype === "Grade"
                                            ? grades?.grade
                                            : (grades?.obtainMarks || "-")}
                                        </td>
                                        {/* Add Written Marks */}
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.writtenMarks || "-"}
                                        </td>
                                        {/* Add Oral Marks */}
                                        <td style={{ padding: "2px", color: 'black' }}>
                                          {grades?.oralMarks || "-"}
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td
                                colSpan={selectedExamName === "All Exams" ? "8" : "3"}
                                style={{ padding: "5px" }}
                              >
                                {language === "English" ? "No data available" : "डेटा उपलब्ध नाही"}
                              </td>
                            </tr>
                          )}
                        </tbody>


                        <tfoot>
                          <tr>
                            <td colSpan="1" style={{ padding: "5px" }}>
                              <b>{language === "English" ? "Total Marks" : "एकूण गुण"}</b>
                            </td>
                            {/* Total M.M and Obt.M for each exam */}
                            {["Unit Test I", "Unit Test II", "Semester First ", "Semester Second "].map((exam, index) => (
                              <>
                                {/* Total M.M (Maximum Marks) */}
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>
                                    {subjectSequence.reduce((total, subject) => {
                                      const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                      return total + (grades?.[exam]?.outOf || 0); // Added safe navigation
                                    }, 0)}
                                  </b>
                                </td>
                                {/* Total Obt.M (Obtained Marks) */}
                                <td colSpan="1" style={{ padding: "5px" }}>
                                  <b>
                                    {subjectSequence.reduce((total, subject) => {
                                      const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                      return total + (grades?.[exam]?.obtainMarks || 0); // Added safe navigation
                                    }, 0)}
                                  </b>
                                </td>
                              </>
                            ))}
                            {/* Grand Total Obt.M */}
                            {/* <td style={{ padding: "5px" }}>
      <b>
        {subjectSequence.reduce((total, subject) => {
          const grades = selectedStudentResults.results[subject];
          return (
            total +
            (grades?.["Unit Test I"]?.obtainMarks || 0) +
            (grades?.["Unit Test II"]?.obtainMarks || 0) +
            (grades?.["Semester First "]?.obtainMarks || 0) +
            (grades?.["Semester Second "]?.obtainMarks || 0)
          );
        }, 0)}
      </b>
    </td> */}
                          </tr>
                          <tr>
                            <td colSpan="1" style={{ padding: "5px" }}>
                              <b>{language === "English" ? "Percentage" : "टक्केवारी"}</b>
                            </td>
                            {selectedExamName === "All Exams" ? (
                              <>
                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const totalMaxMarks = subjectSequence
                                        .filter((subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return grades && (
                                            grades["Unit Test I"]?.obtainMarks ||
                                            grades["Unit Test II"]?.obtainMarks ||
                                            grades["Semester First "]?.obtainMarks ||
                                            grades["Semester Second "]?.obtainMarks
                                          );
                                        })
                                        .reduce((total, subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return total + (grades?.["Unit Test I"]?.outOf || 0); // Added safe navigation
                                        }, 0);
                                      const totalObtainedMarks = subjectSequence
                                        .filter((subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return grades && (
                                            grades["Unit Test I"]?.obtainMarks ||
                                            grades["Unit Test II"]?.obtainMarks ||
                                            grades["Semester First "]?.obtainMarks ||
                                            grades["Semester Second "]?.obtainMarks
                                          );
                                        })
                                        .reduce((total, subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return total + (grades?.["Unit Test I"]?.obtainMarks || 0); // Added safe navigation
                                        }, 0);
                                      return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%" : "0%";
                                    })()}
                                  </b>
                                </td>
                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const totalMaxMarks = subjectSequence
                                        .filter((subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return grades && (
                                            grades["Unit Test I"]?.obtainMarks ||
                                            grades["Unit Test II"]?.obtainMarks ||
                                            grades["Semester First "]?.obtainMarks ||
                                            grades["Semester Second "]?.obtainMarks
                                          );
                                        })
                                        .reduce((total, subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return total + (grades?.["Unit Test II"]?.outOf || 0); // Added safe navigation
                                        }, 0);
                                      const totalObtainedMarks = subjectSequence
                                        .filter((subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return grades && (
                                            grades["Unit Test I"]?.obtainMarks ||
                                            grades["Unit Test II"]?.obtainMarks ||
                                            grades["Semester First "]?.obtainMarks ||
                                            grades["Semester Second "]?.obtainMarks
                                          );
                                        })
                                        .reduce((total, subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return total + (grades?.["Unit Test II"]?.obtainMarks || 0); // Added safe navigation
                                        }, 0);
                                      return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%" : "0%";
                                    })()}
                                  </b>
                                </td>
                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const totalMaxMarks = subjectSequence
                                        .filter((subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return grades && (
                                            grades["Unit Test I"]?.obtainMarks ||
                                            grades["Unit Test II"]?.obtainMarks ||
                                            grades["Semester First "]?.obtainMarks ||
                                            grades["Semester Second "]?.obtainMarks
                                          );
                                        })
                                        .reduce((total, subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return total + (grades?.["Semester First "]?.outOf || 0); // Added safe navigation
                                        }, 0);
                                      const totalObtainedMarks = subjectSequence
                                        .filter((subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return grades && (
                                            grades["Unit Test I"]?.obtainMarks ||
                                            grades["Unit Test II"]?.obtainMarks ||
                                            grades["Semester First "]?.obtainMarks ||
                                            grades["Semester Second "]?.obtainMarks
                                          );
                                        })
                                        .reduce((total, subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return total + (grades?.["Semester First "]?.obtainMarks || 0); // Added safe navigation
                                        }, 0);
                                      return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%" : "0%";
                                    })()}
                                  </b>
                                </td>
                                <td colSpan="2" style={{ padding: "5px" }}>
                                  <b>
                                    {(() => {
                                      const totalMaxMarks = subjectSequence
                                        .filter((subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return grades && (
                                            grades["Unit Test I"]?.obtainMarks ||
                                            grades["Unit Test II"]?.obtainMarks ||
                                            grades["Semester First "]?.obtainMarks ||
                                            grades["Semester Second "]?.obtainMarks
                                          );
                                        })
                                        .reduce((total, subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return total + (grades?.["Semester Second "]?.outOf || 0); // Added safe navigation
                                        }, 0);
                                      const totalObtainedMarks = subjectSequence
                                        .filter((subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return grades && (
                                            grades["Unit Test I"]?.obtainMarks ||
                                            grades["Unit Test II"]?.obtainMarks ||
                                            grades["Semester First "]?.obtainMarks ||
                                            grades["Semester Second "]?.obtainMarks
                                          );
                                        })
                                        .reduce((total, subject) => {
                                          const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                          return total + (grades?.["Semester Second "]?.obtainMarks || 0); // Added safe navigation
                                        }, 0);
                                      return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%" : "0%";
                                    })()}
                                  </b>
                                </td>
                              </>
                            ) : (
                              <td colSpan="2" style={{ padding: "5px" }}>
                                <b>
                                  {(() => {
                                    const totalMaxMarks = subjectSequence
                                      .filter((subject) => {
                                        const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                        return grades && grades?.obtainMarks;
                                      })
                                      .reduce((total, subject) => {
                                        const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                        return total + (grades?.outOf || 0);
                                      }, 0);
                                    const totalObtainedMarks = subjectSequence
                                      .filter((subject) => {
                                        const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                        return grades && grades?.obtainMarks;
                                      })
                                      .reduce((total, subject) => {
                                        const grades = selectedStudentResults?.results?.[subject]; // Added safe navigation
                                        return total + (grades?.obtainMarks || 0);
                                      }, 0);
                                    return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%" : "0%";
                                  })()}
                                </b>
                              </td>
                            )}
                          </tr>
                        </tfoot>



                      </table>
                    ) : (
                      <p style={{ fontSize: '12px' }}>{language === "English" ? "No results available." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}</p>
                    )}

                    <div
                      style={{
                        marginTop: "10px",
                        fontSize: "14px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <p>
                          <strong>
                            {language === "English" ? "Out Of : " : "एकूण : "}
                            {subjectSequence.reduce((total, subject) => {
                              const grades = selectedStudentResults.results[subject];
                              return (
                                total +
                                (grades?.["Unit Test I"]?.outOf || 0) +
                                (grades?.["Unit Test II"]?.outOf || 0) +
                                (grades?.["Semester First "]?.outOf || 0) +
                                (grades?.["Semester Second "]?.outOf || 0)
                              );
                            }, 0)}
                          </strong>
                        </p>
                        <p>
                          <strong>
                            {language === "English" ? "Obtained Marks : " : "प्राप्त गुण : "}




                            {subjectSequence.reduce((total, subject) => {
                              const grades = selectedStudentResults.results[subject];
                              return (
                                total +
                                (grades?.["Unit Test I"]?.obtainMarks || 0) +
                                (grades?.["Unit Test II"]?.obtainMarks || 0) +
                                (grades?.["Semester First "]?.obtainMarks || 0) +
                                (grades?.["Semester Second "]?.obtainMarks || 0)
                              );
                            }, 0)}


                          </strong>
                        </p>
                      </div>
                      <div>
                        <p>
                          <b>
                            {language === "English" ? "Percentage : " : "टक्केवारी : "}
                            <b>
                              {(() => {
                                const totalMaxMarks = subjectSequence
                                  .filter((subject) => {
                                    const grades = selectedStudentResults.results[subject];
                                    return grades && (
                                      grades["Unit Test I"]?.obtainMarks ||
                                      grades["Unit Test II"]?.obtainMarks ||
                                      grades["Semester First "]?.obtainMarks ||
                                      grades["Semester Second "]?.obtainMarks
                                    );
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject];
                                    return total + (grades["Unit Test I"]?.outOf || 0) + (grades["Unit Test II"]?.outOf || 0) + (grades["Semester First "]?.outOf || 0) + (grades["Semester Second "]?.outOf || 0);
                                  }, 0);
                                const totalObtainedMarks = subjectSequence
                                  .filter((subject) => {
                                    const grades = selectedStudentResults.results[subject];
                                    return grades && (
                                      grades["Unit Test I"]?.obtainMarks ||
                                      grades["Unit Test II"]?.obtainMarks ||
                                      grades["Semester First "]?.obtainMarks ||
                                      grades["Semester Second "]?.obtainMarks
                                    );
                                  })
                                  .reduce((total, subject) => {
                                    const grades = selectedStudentResults.results[subject];
                                    return total + (grades["Unit Test I"]?.obtainMarks || 0) + (grades["Unit Test II"]?.obtainMarks || 0) + (grades["Semester First "]?.obtainMarks || 0) + (grades["Semester Second "]?.obtainMarks || 0);
                                  }, 0);
                                return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%" : "0%";
                              })()}
                            </b>
                          </b>
                        </p>
                      </div>
                    </div>
                    <div
                      className="grad"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0 20px',
                      }}
                    >
                      {/* Left-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'left', marginBottom: '2px', marginLeft: '-10px' }}
                        htmlFor="Parent's signature"
                      >
                        {language === "English" ? "Parent's signature" : "पालकांची सही"}
                      </label>
                      {/* Center-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'center', marginBottom: '2px' }}
                        htmlFor="class-teacher"
                      >
                        {language === "English" ? "Class Teacher" : "वर्गशिक्षक"}
                      </label>
                      {/* Right-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'right', marginBottom: '2px', marginRight: '20px' }}
                        htmlFor="principal"
                      >
                        {language === "English" ? "Principal" : "प्राचार्य"}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            ) : (




              <div>
                {/* Semester First  modal content */}
                <div className="r mt-1" style={{}}>
                  <div className="left" style=
                    {{
                      width: '615px',
                      height: '900px',
                      margin: '0 auto', // Center the div horizontally
                      padding: '20px', // Add some padding
                      border: '2px solid #000', // Optional: Add a border for visibility
                      boxSizing: 'border-box', // Include padding and border in the element's total width and height
                      overflow: 'hidden' // Prevent overflow if content is too large
                    }}>
                    <div className="school-info" >
                      {schoolLogo && (
                        <div>
                          <img
                            src={schoolLogo}
                            alt="Logo"
                            style={{ width: '80px', height: 'auto', objectFit: 'contain' }}
                          />
                        </div>
                      )}
                      <h2>{schoolName}</h2>
                    </div>
                    <div>
                      <hr style={{
                        width: 'calc(100% + 40px)', // Adjust width to account for padding
                        height: '2px',
                        backgroundColor: 'black',
                        border: 'none',
                        marginLeft: '-20px', // Negative margin to pull it to the left
                        marginRight: '-20px', // Negative margin to pull it to the right
                        marginBottom: '6px', // Adjust this value to reduce the gap below the hr
                      }} />
                      <b>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? "PROGRESS REPORT" : "विद्यार्थी प्रगती अहवाल"}
                        </h6>
                        <h6 style={{ textAlign: 'center', margin: '0' }}> {/* Set margin to 0 */}
                          {language === "English" ? `${selectedExamName || '-'}  EXAMINATION - ${academicYear}` : `प्रथम सत्र परीक्षा-  ${academicYear}`}
                        </h6>
                      </b>
                      <hr style={{
                        width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '6px', marginBottom: '6px',
                      }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px' }}>
                      <div style={{ flex: '1', textAlign: 'left' }}>
                        <label htmlFor="roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Roll No : " : "हजेरी क्रमांक : "}</label>
                        <span>{selectedStudentResults?.rollNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'center' }}>
                        <label htmlFor="Register No" style={{ fontSize: '14px' }}>{language === "English" ? "Register No : " : "रजिस्टर क्रमांक : "}</label>
                        <span>{selectedStudentResults?.registerNo || '-'}</span>
                      </div>
                      <div style={{ flex: '1', textAlign: 'right', }}>
                        <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Class : " : "वर्ग : "}</label>
                        <span>{classValue || '-'} {division || '-'}</span>
                      </div>
                    </div>
                    <hr style={{
                      width: 'calc(100% + 40px)', height: '2px', backgroundColor: 'black', border: 'none', marginLeft: '-20px', marginRight: '-20px', marginTop: '1px'
                    }} />
                    <div style={{ fontSize: '14px', marginLeft: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ width: '70%' }}>
                        <div>
                          <label htmlFor="student-name" style={{ fontSize: '14px' }}>{language === "English" ? "Student Name : " : "विद्यार्थ्याचे नाव : "}</label>
                          <span>{selectedStudentResults?.studentName || '-'} {selectedStudentResults?.stdFather || '-'} {selectedStudentResults?.stdSurname || '-'}</span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Mother Name : " : "आईचे वर्ग : "}</label>
                          <span>{selectedStudentResults?.stdMother || '-'} </span>
                        </div>
                        <div>
                          <label htmlFor="class" style={{ fontSize: '14px' }}>{language === "English" ? "Date Of Birth : " : "जन्मतारीख : "}</label>
                          <span>{selectedStudentResults?.dob ? selectedStudentResults.dob.split('-').reverse().join('-') : '-'} </span>
                        </div>
                        <div>
                          <label htmlFor="exam-roll-no" style={{ fontSize: '14px' }}>{language === "English" ? "Exam : " : "परीक्षा सत्र : "}</label>
                          <span>{selectedExamName || '-'}</span>
                        </div>
                      </div>
                      <div style={{ width: '30%' }}>
                        {selectedStudentResults?.stdPhoto && (
                          <img src={selectedStudentResults?.stdPhoto} style={{ width: '80px', height: '80px' }} />
                        )}
                      </div>
                    </div>
                    {selectedStudentResults?.results ? (
                      <table className="table table-striped table-bordered" style={{ fontSize: '12px', padding: '5px' }}>
                        <thead>
                          <tr>
                            <th rowSpan="1" style={{ padding: '3px', color: 'black' }}>
                              {language === "English" ? "Subject" : "विषय"}
                            </th>
                            <th style={{ padding: '4px', color: 'black' }}>
                              {language === "English" ? "Max. Marks" : "पैकी"}
                            </th>
                            <th style={{ padding: '4px', color: 'black' }}>
                              {language === "English" ? "Written Marks" : "लेखी गुण"}
                            </th>
                            <th style={{ padding: '4px', color: 'black' }}>
                              {language === "English" ? "Oral Marks" : "तोंडी गुण"}
                            </th>
                            <th style={{ padding: '4px', color: 'black' }}>
                              {language === "English" ? "Total Obtained" : "एकूण गुण"}
                            </th>
                            <th rowSpan="1" style={{ padding: '3px', color: 'black' }}>
                              {language === "English" ? "P %" : "%"}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedStudentResults && selectedStudentResults.results ? (
                            subjectSequence
                              .filter((subject) => {
                                const grades = selectedStudentResults.results[subject];
                                return grades && (
                                  grades.unitTestIObtainMarks ||
                                  grades.unitTestIIObtainMarks ||
                                  grades.obtainMarks ||
                                  grades.grade
                                );
                              })
                              .map((subject) => {
                                const grades = selectedStudentResults.results[subject];
                                const totalOutOf = (grades.outOf || 0);
                                const totalObtainMarks = (grades.obtainMarks || 0);
                                const writtenMarks = (grades.writtenMarks || 0);
                                const oralMarks = (grades.oralMarks || 0);
                                const rowPercentage = totalOutOf > 0 ? ((totalObtainMarks / totalOutOf) * 100).toFixed(2) : "-";

                                return (
                                  <tr key={subject} style={{ padding: "2px" }}>
                                    <td style={{ padding: "2px", color: 'black' }}>{subject}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.subtype === "Grade" ? "-" : (grades.outOf || "-")}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.subtype === "Grade" ? "-" : (grades.writtenMarks || "-")}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>{grades.subtype === "Grade" ? "-" : (grades.oralMarks || "-")}</td>
                                    <td style={{ padding: "2px", color: 'black' }}>
                                      <b>{grades.subtype === "Grade" ? grades.grade : (grades.obtainMarks || "-")}</b>
                                    </td>
                                    <td style={{ padding: "2px" }}>
                                      <b>{grades.subtype === "Grade" ? "-" : rowPercentage}</b>
                                    </td>
                                  </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan="6" style={{ padding: "5px" }}>
                                {language === "English" ? "No data available" : "डेटा उपलब्ध नाही"}
                              </td>
                            </tr>
                          )}

                          {selectedStudentResults && selectedStudentResults.results && (
                            <tr>
                              <td colSpan="1" style={{ padding: "5px" }}>
                                <b>{language === "English" ? "Total Marks" : "एकूण गुण"}</b>
                              </td>
                              <td colSpan="1" style={{ padding: "5px" }}>
                                <b>
                                  {subjectSequence
                                    .filter(subject => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return grades.obtainMarks && grades.subtype !== "Grade";
                                    })
                                    .reduce((total, subject) => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return total + (grades.outOf || 0);
                                    }, 0)}
                                </b>
                              </td>
                              <td colSpan="1" style={{ padding: "5px" }}>
                                <b>
                                  {subjectSequence
                                    .filter(subject => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return grades.writtenMarks && grades.subtype !== "Grade";
                                    })
                                    .reduce((total, subject) => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return total + (grades.writtenMarks || 0);
                                    }, 0)}
                                </b>
                              </td>
                              <td colSpan="1" style={{ padding: "5px" }}>
                                <b>
                                  {subjectSequence
                                    .filter(subject => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return grades.oralMarks && grades.subtype !== "Grade";
                                    })
                                    .reduce((total, subject) => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return total + (grades.oralMarks || 0);
                                    }, 0)}
                                </b>
                              </td>
                              <td colSpan="1" style={{ padding: "5px" }}>
                                <b>
                                  {subjectSequence
                                    .filter(subject => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return grades.obtainMarks && grades.subtype !== "Grade";
                                    })
                                    .reduce((total, subject) => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return total + (grades.obtainMarks || 0);
                                    }, 0)}
                                </b>
                              </td>
                              <td style={{ padding: "5px" }}>
                                <b>
                                  {(() => {
                                    const filteredSubjects = subjectSequence.filter(subject => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return grades.obtainMarks && grades.subtype !== "Grade";
                                    });
                                    const totalMaxMarks = filteredSubjects.reduce((total, subject) => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return total + (grades.outOf || 0);
                                    }, 0);
                                    const totalObtainedMarks = filteredSubjects.reduce((total, subject) => {
                                      const grades = selectedStudentResults.results[subject] || {};
                                      return total + (grades.obtainMarks || 0);
                                    }, 0);
                                    return totalMaxMarks > 0 ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + '%' : '0%';
                                  })()}
                                </b>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <p style={{ fontSize: '18px', textAlign: 'center', marginTop: '20px', color: 'red' }}>
                        {language === "English" ? "! No result available please fill marks." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}
                      </p>
                    )}
                    <div
                      style={{
                        marginTop: "10px",
                        fontSize: "14px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <p>
                          <strong>
                            {language === "English" ? "Out Of : " : "एकूण : "}
                            {subjectSequence
                              .filter(subject => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return grades.obtainMarks;
                              })
                              .reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return total + (grades.outOf || 0);
                              }, 0)}
                          </strong>
                        </p>
                        <p>
                          <strong>
                            {language === "English" ? "Obtained Marks : " : "प्राप्त गुण : "}
                            {subjectSequence.reduce((total, subject) => {
                              const grades = selectedStudentResults?.results?.[subject] || {};
                              return (
                                total +
                                (grades.unitTestIObtainMarks || 0) +
                                (grades.unitTestIIObtainMarks || 0) +
                                (grades.obtainMarks || 0)
                              );
                            }, 0)}
                          </strong>
                        </p>
                      </div>
                      <div>
                        <p>
                          <b>
                            {language === "English" ? "Percentage : " : "टक्केवारी : "}
                            {(() => {
                              const totalMaxMarks = subjectSequence.reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return (
                                  total +
                                  (grades.outOf || 0)
                                );
                              }, 0);
                              const totalObtainedMarks = subjectSequence.reduce((total, subject) => {
                                const grades = selectedStudentResults?.results?.[subject] || {};
                                return (
                                  total +
                                  (grades.obtainMarks || 0)
                                );
                              }, 0);

                              // Calculate percentage
                              return totalMaxMarks > 0
                                ? ((totalObtainedMarks / totalMaxMarks) * 100).toFixed(2) + "%"
                                : "0%";
                            })()}
                          </b>
                        </p>
                      </div>
                    </div>

                    {selectedStudentResults && selectedStudentResults.results ? (
                      <div>
                        <table className="table table-striped table-bordered" style={{ fontSize: '12px', padding: '5px' }}>
                          {/* Your table code here */}
                        </table>
                        {selectedStudentResults.results.remark && (
                          <div style={{ marginTop: "10px" }}>
                            <p>
                              <strong>
                                {language === "English" ? "Remark : " : "टिप्पणी : "}
                                {selectedStudentResults.results.remark}
                              </strong>
                            </p>
                          </div>
                        )}
                      </div>
                    ) : (
                      <p style={{ fontSize: '18px', textAlign: 'center', marginTop: '20px', color: 'red' }}>
                        {language === "English" ? "! No result available please fill marks." : "कोणतेही प्रगतीपत्रक उपलब्ध नाहीत."}
                      </p>
                    )}
                    <div
                      className="grad"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0 20px',
                      }}
                    >
                      {/* Left-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'left', marginBottom: '2px', marginLeft: '-10px' }}
                        htmlFor="Parent's signature"
                      >
                        {language === "English" ? "Parent's signature" : "पालकांची सही"}
                      </label>
                      {/* Center-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'center', marginBottom: '2px' }}
                        htmlFor="class-teacher"
                      >
                        {language === "English" ? "Class Teacher" : "वर्गशिक्षक"}
                      </label>

                      {/* Right-aligned label */}
                      <label
                        style={{ flex: 1, textAlign: 'right', marginBottom: '2px', marginRight: '20px' }}
                        htmlFor="principal"
                      >
                        {language === "English" ? "Principal" : "प्राचार्य"}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
           
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default WebHSC;
